module.exports = __webpack_public_path__ + "img/04_bg.a97b6b51.jpg";